import {
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBCardTitle,
} from "mdb-react-ui-kit";
import { renderFeetOfClayDetails } from "./PubpeerDataReviewUtils";
import { ReportActionButtons } from "../../screened-manuscripts/components/ReportActionButtons";
import { dropdownOptions } from "../../screened-manuscripts/dropdownOptions";
import { ApplyAction } from "../../../components/ApplyAction";

const PubpeerDataReview = ({
  data,
  withSubHeader = false,
  onActionSelect,
  onActionUndo,
}) => {
  const pubPeerHits =
    data?.screening_outcomes?.find((x) => x.type === "pubPeerHits")
      ?.items ?? [];

  return (
    <>
      {pubPeerHits.length > 0 && (
        <MDBCard className="my-2">
          {withSubHeader && (
            <MDBCardHeader className="d-flex align-items-center">
              <ReportActionButtons
                signals={["pubPeerHits"]}
                iconOnly
              />
              <MDBCardTitle className="pt-2 ps-2">Pubpeer</MDBCardTitle>
              <div className="ms-auto">
                <ApplyAction
                  index={data?.manuscript_id}
                  status={data?.submission_status}
                  selectAction={onActionSelect}
                  undoAction={onActionUndo}
                  options={dropdownOptions}
                />
              </div>
            </MDBCardHeader>
          )}
          <MDBCardBody>
            {pubPeerHits.map((item, index) =>
              renderFeetOfClayDetails(item, index)
            )}
          </MDBCardBody>
        </MDBCard>
      )}
    </>
  );
};

export default PubpeerDataReview;
